<template>
  <div class="d-flex justify-content-between justify-content-center">
    <div class="inline">
      <strong>Choose a template:</strong>
      <select v-model="selectedTemplate" :disabled="selectedTemplate.length == 0">
        <option value="" disabled selected hidden>Select</option>
        <option v-for="template in templates" :value="template" :key="template.id">
          {{ template.label }}
        </option>
      </select>
      <button class="btn btn-danger" v-on:click="deleteTemplate" :disabled="selectedTemplate.length == 0">
        Delete
      </button>
    </div>
  </div>
</template>

<script>
import SurveysService from '../../services/surveys-service';
export default {
  props: {
    preselected: {
      required: false,
      type: Object,
    },
  },
  data() {
    return {
      templates: null,
      selectedTemplate: '',
    };
  },
  watch: {
    selectedTemplate: function (newVal, oldVal) {
      if (newVal == '') return;
      this.$emit('selected', newVal);
    },
    preselected: function (newVal, oldVal) {
      if (!newVal) {
        return;
      }
      this.updatePreselected(newVal);
    },
  },
  mounted() {
    this.getTemplates();
  },
  methods: {
    async updatePreselected(newVal) {
      await this.getTemplates();
      this.selectedTemplate = this.templates.filter((templ) => {
        return templ.id == newVal.id;
      })[0];
    },
    async deleteTemplate() {
      try {
        swal(
          {
            title: 'Are you sure you want to delete the template?',
            text: 'The action will be applied right away!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#00aef1',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Delete',
          },
          async (result) => {
            if (result) {
              await SurveysService.responseTemplates.delete(this.selectedTemplate.id);
              await this.getTemplates();
              this.selectedTemplate.isFallback = true;
              this.$emit('template-deleted',this.selectedTemplate);
            }
          },
        );
      } catch (error) {
        swal({
          title: 'Could not delete template',
          text: 'An error occurred while trying to delete the template.',
          type: 'error',
          showCloseButton: true,
          timer: 10000,
        });
      }
    },

    async getTemplates() {
      this.templates = await SurveysService.responseTemplates.index();

      if (this.templates.length > 0) {
        this.selectedTemplate = this.templates[0];
      } else {
        this.selectedTemplate = '';
      }
    },
  },
};
</script>
